import { Box, Typography } from "@mui/material";



export const SixthPage = () => {
    return (
        <Box sx={{ background: '#F3F5F7' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center', alignItems: 'center', width: '80%', py: 3 }}>
                    <Typography sx={{ fontSize: '20px', color: '#0057D5', fontWeight: '700', py: 4 }}>SOCIAL PROOF</Typography>
                    <Typography sx={{ fontSize: '40px', color: '#040815', fontWeight: '700', py: 2 }}>What Our Users Are Saying</Typography>
                    <Typography sx={{ fontSize: '20px', color: '#474747', fontWeight: '500', py: 2 }}>Discover how our product has transformed project<br /> management for teams and organizations.</Typography>
                </Box>
            </Box>
        </Box>
    );
}